import React from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import { StyledInput } from "../styled-input/StyledInput";
import { StyledButton } from "../styled-button/StyledButton";
import * as AuthService from "../../firebase/AuthService";

const validationSchema = yup.object({
  email: yup
    .string("Enter your email")
    .email("Enter a valid email")
    .required("Email is required"),
  password: yup
    .string("Enter your password")
    .min(8, "Password should be of minimum 8 characters length")
    .required("Password is required"),
});
const AuthLogin = (props) => {
  const registerUser = async (values) => {
    const { email, password } = values;
    const userData = await AuthService.loginUser(email, password);
    props.setUser(userData);
  };

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: validationSchema,
    onSubmit: registerUser,
  });

  return (
    <div className={"p-3"}>
      <form onSubmit={formik.handleSubmit} autoComplete={"off"}>
        <StyledInput
          fullWidth
          id="email"
          className={"mb-3"}
          name="email"
          placeholder="Email"
          variant={"filled"}
          value={formik.values.email}
          onChange={formik.handleChange}
          error={formik.touched.email && Boolean(formik.errors.email)}
          helperText={formik.touched.email && formik.errors.email}
          autoComplete="off"
        />
        <StyledInput
          fullWidth
          id="password"
          className={"mb-3"}
          name="password"
          placeholder="Password"
          type="password"
          variant={"filled"}
          value={formik.values.password}
          onChange={formik.handleChange}
          error={formik.touched.password && Boolean(formik.errors.password)}
          helperText={formik.touched.password && formik.errors.password}
          autoComplete="off"
        />
        <StyledButton
          color="primary"
          variant="contained"
          fullWidth
          type="submit"
        >
          Submit
        </StyledButton>
      </form>
    </div>
  );
};

export default AuthLogin;
